export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-gradient-to-br from-primary-500 to-accent-500 rounded-2xl p-8 md:p-12 flex flex-col lg:flex-row items-center gap-8">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">皮皮喵漫画 APP</h2>
            <p className="text-sm md:text-base text-background-50/90 leading-relaxed mb-6 max-w-md mx-auto lg:mx-0">
              随时随地畅享高清漫画阅读体验。支持离线下载、夜间模式和个性化推荐，追更追到停不下来。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="w-full sm:w-auto px-6 py-3 bg-background-50 text-primary-600 font-medium rounded-full hover:bg-background-100 transition-colors whitespace-nowrap text-center cursor-pointer text-sm"
              >
                <i className="ri-apple-fill mr-1.5"></i>iOS 下载
              </a>
              <a
                href="#app"
                onClick={(e) => e.preventDefault()}
                className="w-full sm:w-auto px-6 py-3 bg-background-50/20 border border-background-50/30 text-background-50 font-medium rounded-full hover:bg-background-50/30 transition-colors whitespace-nowrap text-center cursor-pointer text-sm"
              >
                <i className="ri-android-fill mr-1.5"></i>Android 下载
              </a>
            </div>
          </div>
          <div className="flex-shrink-0">
            <img
              src="https://readdy.ai/api/search-image?query=Smartphone%20mockup%20showing%20manga%20reading%20app%20screen%20with%20colorful%20manga%20page%20displayed%20modern%20phone%20design%20floating%20on%20transparent%20background%20clean%20minimal%20presentation%20warm%20orange%20and%20coral%20accents%20digital%20illustration&width=280&height=420&seq=app-mockup&orientation=portrait"
              alt="皮皮喵漫画 APP 界面预览"
              title="皮皮喵漫画 APP - 手机随时追漫"
              className="w-48 md:w-56 h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
}